import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ungroup",
  "use": "ungroup-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ungroup\"><path d=\"M36,214 L36,208 L48,208 L48,220 L42,220 L42,226 L30,226 L30,214 L36,214 Z M36,216 L32,216 L32,224 L40,224 L40,220 L36,220 L36,216 Z\" transform=\"translate(-30 -208)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/ungroup.svg
// module id = 735
// module chunks = 0